// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".home-container[data-v-5954443c] {\n  padding: 1.6rem 0 0;\n  min-height: 100vh;\n  background-color: #fff;\n}\n.home-container .item-wrapper[data-v-5954443c] {\n    display: -webkit-box;\n    display: -webkit-flex;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-pack: center;\n    -webkit-justify-content: center;\n        -ms-flex-pack: center;\n            justify-content: center;\n    margin-bottom: 0.53333rem;\n}\n", ""]);
// Exports
module.exports = exports;
